import React from 'react';

const ViewRendererDebug = ({ fingerprint, viewName, viewId, refreshView, connectionStatus }) => {
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    const getStatusColor = (status) => {
        switch (status) {
            case 'connected': return '#28a745';
            case 'error': return '#dc3545';
            case 'connecting': return '#ffc107';
            default: return '#6c757d';
        }
    };

    const getStatusText = (status) => {
        switch (status) {
            case 'connected': return 'Online';
            case 'error': return 'Błąd';
            case 'connecting': return 'Łączenie';
            default: return 'Offline';
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: '10px',
            right: '10px',
            backgroundColor: 'rgba(0,0,0,0.8)',
            color: 'white',
            padding: '10px',
            borderRadius: '5px',
            fontSize: '12px',
            zIndex: 1000
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '5px',
                paddingBottom: '5px',
                borderBottom: '1px solid rgba(255,255,255,0.2)'
            }}>
                <div style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: getStatusColor(connectionStatus),
                    marginRight: '6px'
                }}></div>
                <span>{getStatusText(connectionStatus)}</span>
            </div>
            <div>FP: {fingerprint}</div>
            <div>View: {viewName}</div>
            {viewId && <div>ViewID: {viewId}</div>}
            <button
                onClick={refreshView}
                style={{
                    marginTop: '5px',
                    padding: '2px 6px',
                    fontSize: '10px',
                    border: 'none',
                    borderRadius: '3px',
                    cursor: 'pointer'
                }}
            >
                ↻
            </button>
        </div>
    );
};

export default ViewRendererDebug;